import React from 'react';
import useBucketImageLoader from '@/hooks/useBucketImageLoader';
import Assets from '@/res/assets';
import styled from 'styled-components';
import { fadeIn, skelton } from '@/lib/css-lib';

export interface BucketImageViewProps {
    url?: string
    imageStyle?: React.CSSProperties
    loadingContents?: React.ReactNode

    shape?: 'round' | 'rect';
}

/**
 * AWS S3のオブジェクトの画面
 * @param props 
 * @returns 
 */
const BucketImageView: React.FC<BucketImageViewProps> = (props) => {

    const isRound = props.shape === 'round';

    const { result, error, loading } = useBucketImageLoader(props.url);

    return <>
        {result ? 
            <AvaterRoundImg style={props.imageStyle} src={result} round={isRound} /> :
        loading ?
            props.loadingContents : 
        error ?
            <img style={props.imageStyle} src={Assets.ERROR_IMAGE} /> :
            <AvaterRoundImg style={props.imageStyle} src={Assets.DEFAULT_AUTHOR_IMAGE} round={isRound} />
        }
    </>
}

export default BucketImageView;

const AvaterRoundImg = styled.img<{ round: boolean }>`
    /* width: 100%;
    height: 100%; */
    object-fit: contain;
    border-radius: ${p => p.round ? '50%' : undefined};
    border: 1px solid ${p => p.theme.colors.bgSub};
    ${fadeIn}
`